export const BASE_ANALYTICS_CONFIG = {
  category: 'Login',
  label: 'Login started'
};
